<script setup lang="ts">
import type { SensorViewValues } from '../../models/sensorViewValues';
import { convertValue, extractMeta, type Value } from '../../utilities/utils';
import DefaultViewWidget from '../../widgets/Default';
import { computed } from 'vue';
import type { PropType } from 'vue';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const temp = computed(() => props.viewValues.values.find((v) => v.type === 'temp'));
const rest = computed(() => props.viewValues.values
  .filter(v => v !== temp.value)
  .map(convertValue)
  .filter(v => v !== undefined) as Array<Value>
);

const params = computed(() => ({
  temp: convertValue(temp.value),
  rest: rest.value,
  meta: extractMeta(props.viewValues)
}));
</script>

<template>
  <DefaultViewWidget v-bind="params" />
</template>
